"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Header = void 0;

require("../style/index.css");

var _preact = _interopRequireWildcard(require("preact"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _render = require("../utils/render.utils");

var _settings = require("../constants/settings");

var _WithFetch = require("./hocs/WithFetch");

var _fetch = require("../utils/fetch.utils");

var _HeaderTop = _interopRequireDefault(require("./header/HeaderTop"));

var _collection = require("../utils/collection.utils");

var _HeaderBottom = _interopRequireDefault(require("./header/HeaderBottom"));

var _function = require("../utils/function.utils");

var _WithToggle = require("./hocs/WithToggle");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Header = /*#__PURE__*/function (_Component) {
  _inherits(Header, _Component);

  var _super = _createSuper(Header);

  function Header() {
    var _this;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_fixWebComponent", function (node) {
      var _fix = function _fix() {
        try {
          if (_this.props.webcomponent && node && node.current && node.current.parentNode && node.current.parentNode.tagName === 'MTN-HEADER') {
            var parentNode = node.current.parentNode;
            var children = parentNode.childNodes;

            for (var i = 0; i < children.length; i++) {
              var item = children[i];
              var className = item.className || '';

              if (className.indexOf(_settings.HEADER_CLASS_NAME) === -1) {
                var to = node.current.getElementsByClassName('mtn-o-header-bottom__content')[0];
                to.appendChild(item);

                if (item && item.className && item.className.includes('m-breadcrumbs')) {
                  item.style.display = 'block';
                } else if (item && item.children && item.children[0] && item.children[0].className.includes('m-breadcrumbs')) {
                  item.children[0].style.display = 'block';
                }
              }
            }
          }
        } catch (e) {}
      };

      _fix();

      var intervals = [10, 50, 100, 250, 500, 1000, 1500, 2000, 3000, 5000, 7500, 10000]; // Fix it for async renderers that don't trigger this function.

      intervals.forEach(function (i) {
        return setTimeout(_fix, i);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "ref", (0, _preact.createRef)());

    return _this;
  }

  _createClass(Header, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._fixWebComponent(this.ref);

      var node = document.getElementById('mtn-header');
      node && node.addEventListener('click', _function.globalClickHandler);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._fixWebComponent(this.ref);

      var node = document.getElementById('mtn-header');
      node && node.removeEventListener('click', _function.globalClickHandler);
      node && node.addEventListener('click', _function.globalClickHandler);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var node = document.getElementById('mtn-header');
      node && node.removeEventListener('click', _function.globalClickHandler);
    }
  }, {
    key: "render",
    value: function render() {
      var headerClassName = _settings.HEADER_CLASS_NAME;
      var props = (0, _render.camelCaseProps)(_objectSpread(_objectSpread({}, this.props), (0, _fetch.flattenConfig)((0, _render.jsonParse)(this.props.config))));

      var className = props.className,
          style = props.style,
          rest = _objectWithoutProperties(props, ["className", "style"]);

      var fullClassName = className || rest["class"];
      var innerChangeLanguage = props.innerChangeLanguage;
      delete rest.configUrl;
      delete rest.config;
      delete rest.children;
      delete rest["class"];
      delete rest.mtnid;
      delete rest.forcelanguage;
      delete rest.innerChangeLanguage;
      var children = this.props.webcomponent ? null : props.children;
      return (0, _preact.h)("header", _extends({
        ref: this.ref,
        className: "".concat(headerClassName, " ").concat(fullClassName ? fullClassName : '')
      }, (0, _collection.omit)(rest, _settings.HEADER_PROPS), {
        style: style,
        id: "mtn-header"
      }), (0, _preact.h)(_HeaderTop["default"], _extends({}, props, {
        innerChangeLanguage: innerChangeLanguage
      })), (0, _preact.h)(_HeaderBottom["default"], _extends({}, props, {
        headerClickHandler: this._headerClickHandler,
        forceUpdateContent: !this.props.webcomponent
      }), children));
    }
  }]);

  return Header;
}(_preact.Component);

exports.Header = Header;
Header.propTypes = {
  /** Add extra className to top element. */
  className: _propTypes["default"].string,

  /** Link for the "skip to main" accessibility button. */
  accessibilitySkipToLink: _propTypes["default"].string,

  /** Label for the "skip to main" accessibility button. */
  accessibilitySkipToLabel: _propTypes["default"].string,

  /** Style object, set on top footer element. */
  style: _propTypes["default"].object,

  /** Active language, value of the active language, required to see the language menu. */
  languagesActive: _propTypes["default"].string,

  /** Array of selectable languages (contains objects with label and value keys). */
  languagesOptions: _propTypes["default"].array,

  /** Function to execute on language selection (first parameter is value, triggers 'mtn:onChangeLanguage' event as well). */
  languagesChangeFunction: _propTypes["default"].func,

  /** Main logo image URL. */
  logosMainUrl: _propTypes["default"].string,

  /** Main logo image alt. */
  logosMainAlt: _propTypes["default"].string,

  /** Main logo link (e.g. "/"). */
  logosMainLink: _propTypes["default"].string,

  /** Sub logo image URL. */
  logosSubUrl: _propTypes["default"].string,

  /** Sub logo image alt. */
  logosSubAlt: _propTypes["default"].string,

  /** Sub logo link (e.g. "/sub"). */
  logosSubLink: _propTypes["default"].string,

  /** Display main logo as a double logo (double width). */
  logosMainDouble: _propTypes["default"].bool,

  /** Display main logo as a small logo in right upper corner. */
  logosMainSmall: _propTypes["default"].bool,

  /** Title of the contact menu. */
  contactTitle: _propTypes["default"].string,

  /** Label of the contact menu button. */
  contactLabel: _propTypes["default"].string,

  /** Sections in the contact flyout, array of objects with keys label, link, href (supports mailto, tel). */
  contactSections: _propTypes["default"].array,

  /** Social links in contact menu; supported keys are title (value is string) and facebook, linkedin, youtube, instagram, twitter, snapchat, googleplus (values are links). */
  contactSocial: _propTypes["default"].object,

  /** Profile user object; if defined the profile menu is displayed, keys are firstName, lastName and avatarUrl.*/
  profileUser: _propTypes["default"].object,

  /** Label for a profile without firstName and lastName.*/
  profileLabel: _propTypes["default"].string,

  /** Label for the login button.*/
  profileLoginLabel: _propTypes["default"].string,

  /** Label for the logout button.*/
  profileLogoutLabel: _propTypes["default"].string,

  /** Alt for the login button.*/
  profileLoginAlt: _propTypes["default"].string,

  /** Alt for the logout button.*/
  profileLogoutAlt: _propTypes["default"].string,

  /** Label for the switch toggle in the profile.*/
  profileToggleLabel: _propTypes["default"].string,

  /** Set the switch state in the profile.*/
  profileToggleChecked: _propTypes["default"].bool,

  /** Function executed when clicking the switch in profile menu (triggers 'mtn:onProfileToggle' event as well). */
  profileToggleFunction: _propTypes["default"].func,

  /** Function executed when clicking on logout button in profile menu (triggers 'mtn:onLogout' event as well). */
  logoutFunction: _propTypes["default"].func,

  /** Function executed when clicking on login button in profile menu (triggers 'mtn:onLogin' event as well). */
  loginFunction: _propTypes["default"].func,

  /** Array of links in user menu; keys are (label and href). */
  profileLinks: _propTypes["default"].array,

  /** Define an url where config can be fetched (in JSON format). Config should be nested in header object inside JSON. */
  configUrl: _propTypes["default"].string,

  /** Optional rendering function for the links (first argument is the link content second is the url). */
  linksRenderFunction: _propTypes["default"].func,

  /** The whole Header config can also be given as a JSON object */
  config: _propTypes["default"].object,

  /** Link for the overview button, required if you want to display the button. */
  overviewLink: _propTypes["default"].string,

  /** Label in the overview button. */
  overviewLabel: _propTypes["default"].string,

  /** Alt text in the overview button. */
  overviewAlt: _propTypes["default"].string,

  /** Function that is called when user click on the search button (bottom part header), required to show search in the bottom part of the header (triggers 'mtn:onSearch' event as well). */
  searchFunction: _propTypes["default"].func,

  /** Placeholder for the search in the bottom part of the header. */
  searchPlaceholder: _propTypes["default"].string,

  /** Initial value for the search in the bottom part of the header. */
  searchQuery: _propTypes["default"].string,

  /** Function that is called when user enters a value in the search input field, should return an array [{value:  '', label: ''}] that is shown as autocomplete (triggers 'mtn:onAutocompleteSearch' event as well). */
  searchAutocompleteFunction: _propTypes["default"].func,

  /** Content of the menu in the bottom part of the header. Should contain at least one element to display the header. Array of menu items ({title: "String", items: ["Array"]}). */
  menuContent: _propTypes["default"].string,

  /** Optional rendering function for the links in the menu (first argument is the link content second is the url)*/
  menuLinksRenderFunction: _propTypes["default"].func,

  /** Label of the menu button in the bottom part of the header. */
  menuLabel: _propTypes["default"].string,

  /** Force hiding the menu. */
  menuHide: _propTypes["default"].bool,

  /** Function that is called when user enter's query in the inline (upper part header) search input, required to show search button (triggers 'mtn:onInlineSearch' event as well). */
  inlineSearchFunction: _propTypes["default"].func,

  /** Text displayed as info in inline search results menu (e.g. loading state). */
  inlineSearchInfo: _propTypes["default"].string,

  /** Array of inline search results. A search result is an object with keys category, title, icon, link, description. */
  inlineSearchResults: _propTypes["default"].array,

  /** Label for the inline search button (upper part header). */
  inlineSearchLabel: _propTypes["default"].string,

  /** Label for the placeholder inside the inline search input. */
  inlineSearchPlaceholder: _propTypes["default"].string,

  /** Optional text to describe total amount of inline search results. */
  inlineSearchAllResultsText: _propTypes["default"].string,

  /** Optional link to all the inline search results. */
  inlineSearchAllResultsLink: _propTypes["default"].string,

  /** Indicate that you are using the header as a webcomponent (i.e. mtn-header). */
  webcomponent: _propTypes["default"].bool
};
Header.defaultProps = {
  className: '',
  style: {},
  webcomponent: false,
  accessibilitySkipToLabel: 'Skip to main content',
  accessibilitySkipToLink: '#main',
  logosMainUrl: _settings.DEFAULT_LOGO,
  logosMainAlt: _settings.DEFAULT_LOGO_ALT,
  logosMainLink: '/',
  logosSubUrl: '',
  logosSubAlt: '',
  logosSubLink: '',
  logosMainDouble: false,
  logosMainSmall: false,
  languagesOptions: _settings.DEFAULT_LANGUAGES,
  languagesActive: '',
  contactTitle: '',
  contactSections: [],
  contactSocial: null,
  languagesChangeFunction: null,
  profileUser: null,
  logoutFunction: null,
  profileToggleFunction: null,
  loginFunction: null,
  linksRenderFunction: null,
  profileLinks: [],
  configUrl: '',
  overviewLink: '',
  profileLabel: 'Mijn profiel',
  profileLoginAlt: 'Aanmelden',
  profileLogoutAlt: 'Afmelden',
  overviewLabel: 'Overzicht',
  overviewAlt: 'Overzicht',
  profileLoginLabel: 'Aanmelden',
  contactLabel: 'Contact',
  profileLogoutLabel: 'Afmelden',
  profileToggleLabel: 'Ben je een medewerker?',
  profileToggleChecked: false,
  searchFunction: null,
  searchAutocompleteFunction: null,
  searchQuery: '',
  searchPlaceholder: 'Wat zoekt u?',
  menuLabel: 'Menu',
  menuHide: false,
  menuLinksRenderFunction: null,
  menuContent: [],
  inlineSearchFunction: null,
  inlineSearchInfo: '',
  inlineSearchResults: [],
  inlineSearchLabel: 'Zoeken',
  inlineSearchPlaceholder: 'Zoeken',
  inlineSearchAllResultsText: '',
  inlineSearchAllResultsLink: ''
};

var _default = (0, _WithToggle.withToggle)((0, _WithFetch.withFetch)(Header, 'header'));

exports["default"] = _default;